import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SoundIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M11.4453 1.16963L7 5.00168H4C3.44772 5.00168 3 5.44939 3 6.00168V10C3 10.5523 3.44772 11 4 11H7L11.4453 14.8337C12.1099 15.2768 13 14.8004 13 14.0017V2.00168C13 1.20299 12.1099 0.726595 11.4453 1.16963Z"
		/>
	</svg>
))
